import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciPopoverComponent } from './luci-popover.component';



@NgModule({
  declarations: [LuciPopoverComponent],
  exports: [LuciPopoverComponent],
  imports: [
    CommonModule
  ]
})
export class LuciPopoverModule { }
